import React from "react";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import leftArrow from "../../../assets/images/svg/back-btn-light.svg";

const useStyles = makeStyles({
  root: {
    color: "#444444",
    padding: "10px 15px",
    fontSize: 12,
    background: "#FFFFFF",
    transition: "0.3s",
    fontWeight: 300,
    borderRadius: 3,
    border: "1px solid #0000001A",
    height: 34,
    minWidth: "max-content",
    lineHeight: "22px",
    display: "flex",
    alignItems: "center",

    "&:hover": {
      opacity: 0.8,
    },

    "& > img": {
      marginRight: 5,
      width: 12,
    },
  },
});

const BackButtonLinkLight = ({ to, children }) => {
  const classes = useStyles();
  return (
    <Link className={classes.root} to={to}>
      <img src={leftArrow} alt="back button" />
      {children}
    </Link>
  );
};

export default BackButtonLinkLight;
